module.exports = __webpack_public_path__ + "static/media/shoonya_gift.46af0521.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shoonya_gift.webp
// module id = 360
// module chunks = 0